import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

export const Page = ({ style, children, ...props }) => (
  <div style={{ marginBottom: "6rem", ...style }} {...props}>
    {children}
  </div>
);

Page.propTypes = {
  /** the contents of the Page */
  children: PropTypes.node.isRequired,
  /** one off styles to apply to the wrapping div */
  style: PropTypes.object
};

const StickyFooter = ({ className, children, style }) => (
  <div className={classNames("sticky-footer", className)} style={style}>
    <div className="sticky-footer__container container">
      <div data-test-id="sticky-footer-children">{children}</div>
    </div>
  </div>
);

StickyFooter.propTypes = {
  /** a class name to provide to the base StickyFooter wrapping div */
  className: PropTypes.string,
  /** the contents of the StickyFooter */
  children: PropTypes.node.isRequired,
  /** one off styles to apply to the base StickyFooter wrapping div */
  style: PropTypes.object
};

export default StickyFooter;
